import "../index.js";
import type {NexusResult, OttoNexus} from "@otto-ec/global-resources/nexus";
import {apps} from "../index.js";

export {DownloadImageError, DownloadImageErrorCause} from "./downloadImageError.js";

export type MediaRaw = {
    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
    downloadImage(imgUrl: string, openImageOnSuccess: boolean): NexusResult<Promise<void>>;

    /**
 *
 */
    downloadImageResult(imgUrl: string, isSuccessful: boolean, errorCode?: string): NexusResult<void>;

}

export type Media = OttoNexus["apps"]["media"]

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export const media: Media = apps.media;

/**
 *
 */
export const downloadImage: Media["downloadImage"] = media.downloadImage;